import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center border-b border-neutral-300 p-4" }
const _hoisted_2 = { class: "t3 -t_semi-bold -pr_2 -mb_0 truncate" }
const _hoisted_3 = { class: "ml-auto shrink-0" }
const _hoisted_4 = {
  key: 0,
  class: "floating-widget__content-main flex grow flex-col overflow-hidden"
}
const _hoisted_5 = { class: "grow overflow-y-auto overflow-x-hidden px-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" }
const _hoisted_6 = {
  key: 0,
  class: "shrink-0 bg-white px-4 py-6"
}

import { onClickOutside } from '@vueuse/core'
import { ref, type Ref, onMounted, getCurrentInstance } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CollapsableFloatingPanel',
  props: {
    title: {},
    collapseOnClickOutside: { type: Boolean, default: true },
    collapsedOnOpen: { type: Boolean, default: false },
    ignoreClickOutsideRefs: {},
    ignoreClickOutsideUiActions: {}
  },
  emits: ["collapse", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const panelRef = ref(null)
const panelCollapsed = ref(props.collapsedOnOpen)

const togglePanelCollapsing = () => {
  panelCollapsed.value = !panelCollapsed.value
  emit('collapse', panelCollapsed.value)
}

const closePanel = () => {
  emit('close')
}

onClickOutside(panelRef, (ev) => {
  let ignoreEventByGivenUiAction = false

  if (ev.target && props.ignoreClickOutsideUiActions) {
    const uiActionEl = (ev.target as HTMLElement).closest('[data-ui-action]')
    const uiActions = Array.isArray(props.ignoreClickOutsideUiActions) ? props.ignoreClickOutsideUiActions : [props.ignoreClickOutsideUiActions]

    if (uiActionEl && uiActions.some((action) => action === (uiActionEl as HTMLElement).dataset.uiAction)) {
      ignoreEventByGivenUiAction = true
    }
  }
  if (!props.collapseOnClickOutside || panelCollapsed.value || ignoreEventByGivenUiAction) return
  togglePanelCollapsing()
}, { ignore: props.ignoreClickOutsideRefs || [] })

onMounted(() => {
  const instance = getCurrentInstance()

  if (instance && instance.proxy) {
    (instance.proxy as unknown as Record<string, unknown>).panelCollapsed = panelCollapsed as Ref<boolean>
    (instance.proxy as unknown as Record<string, unknown>).togglePanelCollapsing = togglePanelCollapsing
  }
})

return (_ctx: any,_cache: any) => {
  const _component_sword_button_wuk = _resolveComponent("sword-button-wuk")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "panelRef",
    ref: panelRef,
    class: "floating-widget fixed bottom-4 right-4 z-50 flex w-[25rem] flex-col overflow-hidden rounded-2xl bg-white"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_sword_button_wuk, {
          icon: panelCollapsed.value ? 'chevron-up' : 'chevron-down',
          theme: "transparent",
          size: "medium",
          round: "",
          onClickNative: togglePanelCollapsing
        }, null, 8, ["icon"]),
        _createVNode(_component_sword_button_wuk, {
          icon: "close",
          theme: "transparent",
          size: "medium",
          round: "",
          onClickNative: closePanel
        })
      ])
    ]),
    _createVNode(_Transition, {
      name: "collapse",
      appear: ""
    }, {
      default: _withCtx(() => [
        (!panelCollapsed.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "default")
              ]),
              (_ctx.$slots.footer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _renderSlot(_ctx.$slots, "footer")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 3
    })
  ], 512))
}
}

})